// Pipeline placeholder data
export const PLACEHOLDER_PIPELINE = [
  {
    id: '1',
    name: 'Alex Johnson',
    company: 'TechCorp',
    email: 'alex.johnson@example.com',
    phone: '(555) 123-4567',
    value: 50000,
    stage: 'qualified' as const,
    industry: 'Technology',
    createdAt: '2024-04-01T10:30:00Z',
    updatedAt: '2024-04-10T14:20:00Z'
  },
  {
    id: '2',
    name: 'Sam Taylor',
    company: 'MediHealth',
    email: 'sam.taylor@example.com',
    phone: '(555) 987-6543',
    value: 120000,
    stage: 'proposal' as const,
    industry: 'Healthcare',
    createdAt: '2024-03-15T09:45:00Z',
    updatedAt: '2024-04-05T11:30:00Z'
  },
  {
    id: '3',
    name: 'Jordan Rivera',
    company: 'InvestGroup',
    email: 'jordan.rivera@example.com',
    phone: '(555) 456-7890',
    value: 85000,
    stage: 'negotiation' as const,
    industry: 'Finance',
    createdAt: '2024-02-20T13:15:00Z',
    updatedAt: '2024-03-25T16:45:00Z'
  },
  {
    id: '4',
    name: 'Morgan Chen',
    company: 'RetailPlus',
    email: 'morgan.chen@example.com',
    phone: '(555) 789-0123',
    value: 35000,
    stage: 'lead' as const,
    industry: 'Retail',
    createdAt: '2024-03-28T08:20:00Z',
    updatedAt: '2024-04-02T10:10:00Z'
  },
  {
    id: '5',
    name: 'Jamie Wilson',
    company: 'MediHealth',
    email: 'jamie.wilson@example.com',
    phone: '(555) 234-5678',
    value: 85000,
    stage: 'closed' as const,
    industry: 'Healthcare',
    createdAt: '2024-01-20T10:15:00Z',
    updatedAt: '2024-04-01T15:40:00Z'
  }
];
